export const constantly = (x) => () => x;
